import { render, staticRenderFns } from "./AdminServicesList.vue?vue&type=template&id=23bdc05c&scoped=true&"
import script from "./AdminServicesList.vue?vue&type=script&lang=ts&"
export * from "./AdminServicesList.vue?vue&type=script&lang=ts&"
import style0 from "./AdminServicesList.vue?vue&type=style&index=0&id=23bdc05c&lang=scss&scoped=true&"
import style1 from "./AdminServicesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bdc05c",
  null
  
)

export default component.exports